import { render } from "./GearAtmosphere.vue?vue&type=template&id=457c17a3&scoped=true"
import script from "./GearAtmosphere.vue?vue&type=script&lang=js"
export * from "./GearAtmosphere.vue?vue&type=script&lang=js"

import "./GearAtmosphere.vue?vue&type=style&index=0&id=457c17a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457c17a3"]])

export default __exports__